export default __webpack_public_path__ + "media/images/banner/banner-22-ef7c71c537780078dddc480201c577dc.jpg";